import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    sintomasAS: [],
  },

  getters: {
    getSintomasAS: (state) => state.sintomasAS,
  },

  mutations: {
    SET_SINTOMAS_AS(state, sintomasAS) {
      state.sintomasAS = sintomasAS;
    },
  },

  actions: {
    async fetchSintomasAS({ commit }, idAparatoSistema) {
      await axios
        .get(`PoliciaCuadrantes/C3/aparatoSistema/${idAparatoSistema}/sintomasAS`)
        .then((response) => {
          commit('SET_SINTOMAS_AS', response.data.data);
        });
    },
  },
};
